export enum WarningType {
  Activity,
  Weather,
  HSE,
  Consumable,
  Personnel,
  CustomData,
  Progress,
  ProgressWithoutTarget,
  TableOfColumn,
}
